module.exports = __webpack_public_path__ + "img/flag-nav.0aad8a90.svg";